<template lang="html">
    <div class="row">
        <div class="col-12 grid-margin">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-4">Payment Setting</h5>
                    <form class="forms-sample">
                        <b-form-group label="Merchant Number">
                            <b-form-input v-model="paymentSubscription.merchantNumber" 
                                          type="text" >
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Access Key">
                            <b-form-input v-model="paymentSubscription.accessKey" 
                                          type="text" >
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="Secret Key">
                            <b-form-input v-model="paymentSubscription.secretKey" 
                                          type="text">
                            </b-form-input>
                        </b-form-group>
                        <b-form-group label="MD5 Key">
                            <b-form-input v-model="paymentSubscription.md5Key" 
                                          type="text" >
                            </b-form-input>
                        </b-form-group>
                        
                        <b-button variant="success" 
                                  class="mr-2"
                                  v-on:click="handleBtnSave">
                                  Save
                        </b-button>
                        <b-button variant="light" 
                                  v-on:click="handleBtnCancel">
                                  Cancel
                        </b-button>
                    </form>
                </div>
            </div>
        </div>      
    </div>
</template>

<script lang="js">
export default{
    name: 'payment',
    data () {
        return {
            paymentSubscription : {
                secretKey : '',
                accessKey : '',
                merchantNumber : '',
                md5Key : ''
            }
        }
    },
    methods: {
        async handleBtnSave () {
            await this.$store.dispatch('paymentsubscription/updatePaymentSubscriptionAction', this.paymentSubscription);
            this.$router.push('/');
        },
        handleBtnCancel () {
            this.$router.push('/');
        }
    },
    created () {
        
    }
}
</script>